import { createSelector } from 'reselect'
import pendingRequestsSelector from './pendingRequestsSelector'

const someRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests) => Object.values(pendingRequests).some((requestCount) => requestCount > 0),
)

export default someRequestIsPendingSelector
